module.exports = __webpack_public_path__ + "img/module-thumb.4da2f460.jpg";